<template>
  <section class="table">
    <el-table
      ref="table"
      :data="tableData"
      :show-header="showHeader"
      style="width: 100%"
      highlight-current-row
      :row-class-name="'table-pointer'"
      :header-row-class-name="'tableHeader'"
      @row-click="rowClick">
      <el-table-column
        width="69"
        align="center">
        <template #default="{ row }">
          <div class="flex-column  flex-align-center">
            <span
              v-if="row.merchant_platform"
              class="table-icon__img mg-b-8">
              <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
            </span>
            <font-awesome-icon  icon="ticket-alt"></font-awesome-icon>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160">
        <template #default="{ row }">
          <div class="flex-algin">
            <p> <span class="span-status type-status">{{ row.type_language }}</span></p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Subject"
        min-width="230">
        <template #default="{ row }">
          <div class="flex-algin">
            <div class="flex flex-circle">
              <div
                class="blue-circle"
                :class="{'yellow-circle':row.is_snooze === 1,'blue':row.client_updated==1}"
                @click.stop="handlerBluePoint(row.$index)">
              </div>
              <router-link
                class="showLink"
                :to="rowClickFn(row)">
                {{ row.subject }}
              </router-link>
            </div>
            <p class="liter-text">{{ row.ticket_number }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="csHome"
        prop="requester"
        :show-overflow-tooltip="true"
        label="Requester">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="text-span">{{ row.requester }}</span>
            <p class="liter-text">{{row.phone?row.phone:''}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="assignee"
        label="Assigned">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="text-span">{{ row.assignee }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Status & Stage"
        width="150px">
        <template #default="{ row }">
          <div class="flex-algin">
            <div>
              <i
                class="status-height"
                :class="{
                  'status-one':row.status==1,
                  'status-two':row.status==2,
                  'status-three':row.status==3
                }">{{ row.status_language }}</i>
            </div>
            <p>
              <i
                v-if="row.stts_language"
                class="span-status-stts"
                :class="{
                  'orange-light': [1, 3,5].includes(row.stts)&&row.type==2||row.type==3&&[101,301].includes(row.stts),
                  'yellow-dark':[0].includes(row.stts)&&row.type==2||row.type==4&&[1].includes(row.stts)||(row.type==5||row.type==6||row.type==3)&&[0].includes(row.stts),
                  'blue': [2,4].includes(row.stts)&&row.type==2||row.type==4&&[4].includes(row.stts)||row.type==3&&[201,501].includes(row.stts)||row.type==6&&[1].includes(row.stts),
                  'green': [6].includes(row.stts)&&row.type==2||row.type==4&&[2].includes(row.stts)||row.type==3&&[601].includes(row.stts)||row.type==5&&[1].includes(row.stts)||row.type==6&&[2].includes(row.stts),
                  'red': [6].includes(row.stts)&&row.type==3||row.type==4&&[3].includes(row.stts)||row.type==3&&[401].includes(row.stts),
                }">{{ row.stts_language }}</i>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        width="160"
        label="Created">
        <template #default="{ row }">
          <span class="liter-time">{{ row.created_at.split(" ")[0] }}</span><br>
          <span class="liter-time"> {{ row.created_at.split(" ")[1] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <v-pagination
      v-if="showHeader"
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import { getAllTicketList, getUnresolvedTicketList } from '@/api/ticket'
import { getAccountTicketList } from '@/api/account'
import { mapActions } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'ListTable',
  mixins: [MixinOptions],
  props:{
    showHeader:{
      type: Boolean,
      default: true,
    },
    customerId:{
      type: [String, Number],
      default: null
    },
    size: {
      type: Number,
      default: 20
    },
    otherData:{
      type: Object,
      default: () => {}
    },
    csHome: {
      type: Boolean,
      default: false
    },
    isFina: {
      type:  Boolean,
      default: false
    },
  },
  data () {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData: []
    }
  },
  watch: {
    otherData:{
      deep: true,
      handler(){
        this.network().getAccountTicketList()
      }
    },
    customerId:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountTicketList()
        }
      }
    },
    csHome:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountTicketList()
        }
      }
    },
    isFina:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountTicketList()
        }
      }
    }
  },
  methods: {
    ...mapActions('account', ['setCustomerFilter']),
    rowClick(row) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
      this.setCustomerFilter({
        ticket: this.otherData
      })
    },

    // 新标签打开链接
    rowClickFn(row){
      return({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAccountTicketList()
    },

    network() {
      return {
        getAccountTicketList: async () => {
          if(this.csHome){
            var { data } = await getUnresolvedTicketList({
              // type: this.type,
              // stts: this.stts,
              // status: this.status,
              size: this.size,
              page: this.pageConfig.currentPage,
              ...this.otherData,
            })
          }else{
            var { data } = await getAccountTicketList({
              customer_id: this.customerId,
              page: this.pageConfig.currentPage,
              size: this.size,
              status: [1, 2],
              ...this.otherData,
              merchant_platform:this.isFina?2:1
            })
          }
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.$emit('getTicketNum', data.total)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.table{
  .span-status {
    margin-right: 5px;
    padding: 0 8px;
    border-radius: 25px;
    white-space: nowrap;

    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .status-height{
    height: 18px;
    line-height: 18px;
    padding: 0px 10px;
  }
  .status-two{
    border: 1px solid #0366D6;
    color: #0366D6;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .status-one{
    border: 1px solid #735C0F;
    color: #735C0F;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
  }
  .status-three{
    border: 1px solid #22863A;
    color: #22863A;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    font-style: normal;
    font-weight: 600;
  }
  .span-status-stts{
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: inline-block;
    color: #FFFFFF;
    padding: 0px 8px;
    height: 18px;

    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    height: 18px;
  }
  .el-table{
    border: 1px solid #D1D5DA;
    border-radius: 6px 6px 0px 0px;
    .flex-algin{
      p,span{
        height: 24px;
      }
      .flex-circle{
        min-height: 24px;
        align-items: center;
        span{
          color: #24292E;
          font-size: 14px;
          font-weight: 600;
        }
      }
      p:first-child{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
        span{
          font-weight: 600;
        }
      }
    }
    .liter-time{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #24292E;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .text-span{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
  }
  .showLink{
    color:  #000;
    text-decoration: none;
    font-weight: 600;
    &:hover{
      color:  #0366D6;
    }
  }

  /deep/ .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        .cell{
          line-height: 23px;
          position: relative;
          height: inherit;
          padding: 0;
        }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }

  /deep/ .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }
}
</style>
